import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, watch } from 'vue';
import { type ContextMenuItem, type ContextMenu, CONTEXT_MENU_ACTION, CONTEXT_MENU_EVENT, CONTEXT_MENU_ID } from '@/angular-app/libs/fabric/fabric.contextmenu';
import type { CanvasEx } from '@/typings/canvas';
import type { Object as FabricObject } from 'fabric/fabric-impl';
import { DatadogEvent, fireDatadogLog } from '@/utils/datadogUtils';
import { useToaster } from '@/composables/toaster';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasContextMenu',
  props: {
    canvas: null,
    events: null
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    events?: Record<CONTEXT_MENU_ACTION, (element?: FabricObject) => void>
};

_useCssVars((_vm, _setup) => ({
  "15d4405b": (_setup.menu.y),
  "15d4405a": (_setup.menu.x)
}))



const menu = reactive({
    x: '0px',
    y: '0px',
    items: [] as ContextMenuItem[],
    element: undefined as FabricObject | undefined
});

const toast = useToaster();
const handleItemClick = (item: ContextMenuItem) => {
    try {
        const callback = item.onClick || props.events?.[item.action!];
        callback?.(menu.element);
    } catch (error) {
        const msg = `Error executing action ${item.label}`
        toast.error(msg);
        console.error(msg, error);
    } finally {
        onMenuClosed();
        fireDatadogLog(`${item.label} - Right Click Menu` as DatadogEvent);
    }

};

const onMenuOpened = (event: ContextMenu) => {
    menu.x = `${event.x}px`;
    menu.y = `${event.y}px`;
    menu.items = [...event.items];
    menu.element = event.selectedElement;
};

const onMenuClosed = () => {
    menu.items = [];
};

watch(
    () => props.canvas,
    (canvas) => {
        if (!canvas) return;
        props.canvas.on(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
        props.canvas.on(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
    },
    { immediate: true }
);

onUnmounted(() => {
    props.canvas.off(CONTEXT_MENU_EVENT.SHOW, onMenuOpened);
    props.canvas.off(CONTEXT_MENU_EVENT.HIDE, onMenuClosed);
});

return { __sfc: true,props, menu, toast, handleItemClick, onMenuOpened, onMenuClosed, CONTEXT_MENU_ID }
}

})